export const COOKIE_CATEGORIES = {
    analytics: 'analytics',
    basic: 'basic',
    essential: 'essential',
    marketing: 'marketing',
    personalisation: 'personalisation',
    unclassified: 'unclassified',
} as const;
